import React, { Fragment, useState } from 'react';


const NewWorker = ({ refresh_workers }) => {

    const [worker_name, setWorker_name] = useState("");
    const [worker_email, setWorker_email] = useState("");
    const [viewer, setViewer] = useState(false);
    const [success, setSuccess] = useState(false);
    const [exists, setExists] = useState(false);
    
    function reset() {
        setWorker_name("");
        setWorker_email("");
        setViewer(false);
        setSuccess(false);
        setExists(false);
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();

        var worker_password = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
        var charactersLength = characters.length;
        for (var i = 0; i < 10; i++) {
            worker_password += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }

        const body = { worker_name, worker_email, worker_password, viewer }

        const response = await fetch("/auth/register", {
            method: "POST",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        }).then(function (response) {
            if (response.status == 401 || response.status == 403 || response.status == 409) {
                setExists(true)
                setSuccess(false)
            } else {
                setSuccess(true)
                setExists(false)
                setWorker_email("");
                setWorker_name("");
                setViewer(false)
            }
        })
        refresh_workers()
    }


    return (
        <Fragment>
            <button type="button" className="btn btn-info m-3 float-right" data-toggle="modal" data-target={`#newWorker`}>
                Add new worker
            </button>

            <div className="modal fade" id={`newWorker`}>
                <div className="modal-dialog">
                    <div className="modal-content">



                        <div className="modal-header">
                            <h4 className="modal-title">Add a new worker</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => reset()}>&times;</button>
                        </div>

                        <form onSubmit={onSubmitForm}>
                            <div className="modal-body">
                                <p className="mt-2">Name</p>
                                <input required placeholder="Name" type="text" className="form-control" value={worker_name} onChange={e => setWorker_name(e.target.value)} />
                                <p className="mt-2">Email</p>
                                <input required placeholder="Email" type="email" className="form-control" value={worker_email} onChange={e => setWorker_email(e.target.value)} />
                                <input placeholder="Viewer" type="checkbox" className="form-check-input ml-2 mt-2" id="viewer_check" value={viewer} onChange={e => setViewer(e.target.checked)} />
                                <label className="form-check-label ml-5 mt-1" htmlFor="viewer_check">
                                    Viewer
                                </label>
                                <br />
                                <button className="btn btn-success mt-1">Create</button>
                                {success && <p className="text-success">It Worked</p>}
                                {exists && <p className="text-danger">User already exists!</p>}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-dismiss="modal" onClick={() => reset()}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default NewWorker;